module.exports = "<div class=\"container\">\n  <div class=\"status\">\n    <h1 ng-show=\"!ctrl.isFetchingPage\">{{ ctrl.status }}</h1>\n    <img src=\"/static/images/ring.gif\"/>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/partials/zoho-landing.html
// module id = 323
// module chunks = 0